import { render } from "./GccsSetUser.vue?vue&type=template&id=32fc72b6"
import script from "./GccsSetUser.vue?vue&type=script&lang=js"
export * from "./GccsSetUser.vue?vue&type=script&lang=js"

import exportComponent from "D:\\VueProject\\leeten-hrm-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__